const env = process.env;

const config = {
  APIURL:env.REACT_APP_BASE_URL,
  PORT:env.REACT_APP_BASE_PORT,
};

module.exports = config;
